import React from 'react';

import { useQuery, Loading, Error, SelectInput, required } from 'react-admin';


const InsNames = () => {
  
    const { data, loading, error } = useQuery({ 
        type: 'getList',
        resource: 'instrumentnames',
        payload:  {
            pagination: { page: 1 , perPage: 20 },
            sort: { field: 'name', order: 'ASC' }
        }
    });
 
    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    //controlnums = data;
    return (
        <SelectInput source="code" label='' choices={data}  validate={required()} />
    );
};

export default InsNames;